import { service } from '@ember/service';
import { cached } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { TourId } from 'webapp/enums/tour';

import type ReportsAddNoteTour from 'webapp/models-custom/tour/reports/add-note';
import type ReportsCreateNewSlideTour from 'webapp/models-custom/tour/reports/create-new-slide';
import type ReportsPresentTour from 'webapp/models-custom/tour/reports/present';
import type ReportsReorderSlidesTour from 'webapp/models-custom/tour/reports/reorder-slides';

import FlowTourBaseService from 'webapp/services/flow/tour/base';

export type SlidesTour =
	ReportsCreateNewSlideTour | ReportsReorderSlidesTour | ReportsAddNoteTour | ReportsPresentTour;

export interface SlidesTourSettings {
	id: TourId;
	checkStartConditions: () => boolean;
}

export default class FlowTourReportsSlidesService extends FlowTourBaseService {
	@service('navigation') declare navigationService: Service.Navigation;

	@cached
	get orderedTourIds(): TourId[] {
		return [
			TourId.REPORTS__CREATE_NEW_SLIDE,
			TourId.REPORTS__REORDER_SLIDES,
			TourId.REPORTS__ADD_NOTE,
			TourId.REPORTS__PRESENT,
		];
	}

	override checkGeneralEligibility(): boolean {
		const routePath = String(this.navigationService.activatedRoute);
		return (
			super.checkGeneralEligibility() &&
			routePath.includes('reports') &&
			this.currentUserService.deviceString === 'desktop'
		);
	}
}

declare module '@ember/service' {
	interface Registry {
		'flow/tour/reports-slides': FlowTourReportsSlidesService;
	}
}
